import { render, staticRenderFns } from "./message-recipients-screen.vue?vue&type=template&id=bb173030&"
import script from "./message-recipients-screen.vue?vue&type=script&lang=js&"
export * from "./message-recipients-screen.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports